import React, { useState } from "react";
// import { changeLanguage } from "../utils/languageUtil"; // Import the language utility
import { useTranslation } from "react-i18next";
import i18next from "i18next";
import styles from "./LanguageSelector.module.css";

// SVG Arrows for dropdown
const DownArrowSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="currentColor"
    className={`w-4 h-4 ml-2 2xl:w-6 2xl:h-6 ${styles.icon}`}
  >
    <path
      fillRule="evenodd"
      d="M12 14.25a.75.75 0 0 1-.53-.22l-5.25-5.25a.75.75 0 1 1 1.06-1.06L12 12.94l4.72-4.72a.75.75 0 0 1 1.06 1.06l-5.25 5.25a.75.75 0 0 1-.53.22z"
      clipRule="evenodd"
    />
  </svg>
);

const UpArrowSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="currentColor"
    className={`w-4 h-4 ml-2 2xl:w-6 2xl:h-6 ${styles.icon}`}
  >
    <path
      fillRule="evenodd"
      d="M12 9.75a.75.75 0 0 1 .53.22l5.25 5.25a.75.75 0 0 1-1.06 1.06L12 11.06l-4.72 4.72a.75.75 0 1 1-1.06-1.06l5.25-5.25a.75.75 0 0 1 .53-.22z"
      clipRule="evenodd"
    />
  </svg>
);

const LanguageSelector: React.FC = (props) => {
  const { i18n } = useTranslation();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [selectedLanguage, setSelectedLanguage] = useState(i18n.language);

  // Available languages
  const languages = [
    { value: "Arabic", label: "Arabic" },
    { value: "German", label: "German" },
    { value: "English", label: "English" },
    { value: "Spanish", label: "Spanish" },
    { value: "French", label: "French" },
    { value: "Hindi", label: "Hindi" },
    { value: "Japanese", label: "Japanese" },
    { value: "Portuguese", label: "Portuguese" },
    { value: "Russian", label: "Russian" },
    { value: "Vietnamese", label: "Vietnamese" },
    { value: "Chinese", label: "Chinese" },
  ];

  // Sort languages alphabetically by label
  const sortedLanguages = languages.sort((a, b) =>
    a.label.localeCompare(b.label)
  );

  // Toggle dropdown open/close
  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  // Handle language change
  const handleLanguageChange = (language: string) => {
    i18next.changeLanguage(language); // Use the utility to change language
    setSelectedLanguage(language);
    setIsDropdownOpen(false); // Close dropdown after selection
  };

  return (
    <div className={`relative pb-2 text-sm ${styles.label}`}>
      <button
        onClick={toggleDropdown}
        className={`flex items-center text-sm 2xl:text-base ${styles.text}`}
      >
        {selectedLanguage} {isDropdownOpen ? <UpArrowSvg /> : <DownArrowSvg />}
      </button>

      {isDropdownOpen && (
        <div
          className={`absolute z-10 mt-2 w-28 lg:w-36 h-32 lg:h-48 bg-white text-black max-h-48 overflow-y-auto ${styles.box}`}
        >
          {sortedLanguages.map((lang) => (
            <button
              key={lang.value}
              onClick={() => handleLanguageChange(lang.value)}
              className={`block 2xl:text-base w-full text-left px-4 py-2 hover:bg-gray-200 ${
                selectedLanguage === lang.value ? "text-red-500" : "text-black"
              }`}
            >
              {lang.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default LanguageSelector;
